import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import appConfig from 'app-config';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLCapitalizeStringFilter } from 'ml-portals-util-js';
import metadata from './MLEmployersAffiliationsSummaryCard.metadata.json5';
import styles from './MLEmployersAffiliationsSummaryCard.module.scss';
import messages from './MLEmployersAffiliationsSummaryCard.messages';

function MLEmployersAffiliationsSummaryCard(props) {
    const isQB = appConfig.portalCode === 'QB';
    const { model, employerNotListed, showErrors, removeSelection, isModernProduct, isPaymentScreen} = props;
    const paypointCommentsConsumer = _.get(model, 'paypointCommentsConsumer.value', '');
    const paypointEligibilityComments = _.get(model, 'paypointEligibilityComments.value', '')
    const translator = useTranslator();
    const companyComments = _.get(model, 'companyConsumerFacingComments.value', '');

    const overrides = {
        paypointEligibilityComments: {
            visible: false,
            content: translator(messages.paypointEligibilityComments,
                { paypointEligibilityComments })
        },
        paypointCommentsConsumer: {
            visible: false,
            content: translator(messages.paypointEligibilityCommentsConsumer,
                { paypointCommentsConsumer })
        },
        companyComments: {
            visible: false,
            content: companyComments
        },
        validEmployerContainer: {
            visible: !employerNotListed
        },
        employerNotListedMessage: {
            visible: employerNotListed
        },
        companyName: {
            value: MLCapitalizeStringFilter.capitalize(_.get(model, 'companyName.value', ''))
        },
        paypointName: {
            visible: isQB,
            content: translator(messages.paypointName,
                { paypointName: MLCapitalizeStringFilter.capitalize(_.get(model, 'paypointName.value', '')) })
        },
        gpcCode: {
            content: translator(messages.gpcCode,
                { gpcCode: _.get(model, 'gpcCode.value', '') })
        },
        payPeriod: {
            content: translator(messages.payPeriod,
                { payPeriod: _.get(model, 'payPeriod.value', '') })
        },
        removeSelectedButton: {
            visible: !(isQB && isModernProduct && isPaymentScreen),
            'aria-label': 'Edit Employer or Affiliation'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onRemoveSelection: removeSelection,
        }
    };


   return (
    model.companyName.value !== undefined ? (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={model}
            classNameMap={styles}
            callbackMap={resolvers.resolveCallbackMap}
            overrideProps={overrides}
            showErrors={showErrors}
        />
    ) : <></>
);
}

MLEmployersAffiliationsSummaryCard.propTypes = {
    model: PropTypes.shape({
        accountName: PropTypes.string,
        gpcCode: PropTypes.string,
        payPeriod: PropTypes.string,
        paypointNumber: PropTypes.string
    }).isRequired,
    employerNotListed: PropTypes.bool,
    isModernProduct: PropTypes.bool,
    isPaymentScreen: PropTypes.bool
};

MLEmployersAffiliationsSummaryCard.defaultProps = {
    employerNotListed: false,
    isModernProduct: false,
    isPaymentScreen: false
};

export default MLEmployersAffiliationsSummaryCard;
